<ng-container *ngIf="bundle; else noBundle">
  <h1 class="bundletitle">Package: {{bundle.title}}</h1>
  <p>
    <strong *ngIf="bundle.Access && bundle.Expires">Your subscription to this package is valid through
      {{bundle.Expires | date:'mediumDate'}}</strong>
    <strong *ngIf="bundle.Access && !bundle.Expires">Purchased</strong>
    <app-add-bundle-to-cart *ngIf="bundle.CanPurchase" [bundle]="bundle"></app-add-bundle-to-cart>
  </p>

  <app-dynamic-content *ngIf="!ucdService.IsLoggedIn"
    blocktitle="Package Header - {{bundle.product_code}} Anonymous">
  </app-dynamic-content>
  <app-dynamic-content *ngIf="ucdService.IsLoggedIn"
    blocktitle="Package Header - {{bundle.product_code}} {{lmsUserService.User.GetMemberTypes('ABMP').shift()}}">
  </app-dynamic-content>

  <p [innerHTML]="bundle.description"></p>

  <ng-container *ngIf="courses; else loading">
    <h3>There are {{courses.length}} courses in this package</h3>
    <app-course-listview-list [courses]="courses"></app-course-listview-list>
  </ng-container>
</ng-container>

<ng-template #noBundle>
  <app-html-widget blocktitle="Package Not Found"></app-html-widget>
</ng-template>
<ng-template #loading>
  <app-load-indicator description="load the courses for this package"></app-load-indicator>
</ng-template>
